module.exports = __webpack_public_path__ + "static/img/waiter.2b18a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/waiter.png
// module id = d+Z3
// module chunks = 1